import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import CollapseComponent from './CollapseComponent';
import { getGridStringOperators } from '@mui/x-data-grid';
import ApiService from '../../functions/apiService';
import { Chip } from '@mui/material';
import AuthContext from '../../context/AuthContext';
import { Checkbox } from '@mui/material';
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { toast } from 'react-toastify';

export function OutOfTown({ onExpandChange, open }) {
  const data = useSelector((state) => state.dashboardReducer.Data)
  const [rows, setRows] = useState([])
  let columns = [
    {
      field: 'position', headerName: 'position', flex: 1, minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: 'name', headerName: 'Name', flex: 1, minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: 'out_of_town_date', headerName: 'Out of town date', flex: 1, minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];

  useEffect(() => {
    ApiService.get('/todayOutOfTown', {
      "date": data.date,
    }, 'todayOutOfTown').then(({ data }) => {
      // console.log('dataRes', data.data)
      setRows(data.data)
    }).catch(({ error }) => {
      console.log('error', error)
    });
  }, [])

  return <>
    {rows && rows.length > 0 &&
      <CollapseComponent
        rows={rows}
        columns={columns}
        name={'Out of town'}
        checkboxSelection={false}
        open={open}
        onExpandChange={onExpandChange}
      />
    }
  </>
}

export function Available({ onExpandChange, open, isReload, setIsReload }) {
  const { pages } = useContext(AuthContext);
  const data = useSelector((state) => state.dashboardReducer.Data);
  const [availableData, setAvailableData] = useState([]);
  const [unavailableData, setUnAvailableData] = useState([]);
  const [availabilityData, setAvailabilityData] = useState([]);
  const displayFlag = pages.includes("AVAILABILITY_DISPLAY_UNAVAILABLE")
  const key = "24";
	const [assign, setAssign] = useState(null);

	const columns = (checkbox = false) => {
		let columnsArr = [
			{
				field: 'Name', headerName: 'Name', flex: 1,
				renderCell: (params) => {
					return ((params?.row?.EA_Rank ? params?.row?.EA_Rank : '') + ' ' + params?.row?.First_name + ' ' + params?.row?.Last_name)
				}
			},
			{
				field: 'hours', headerName: 'Duration', flex: 1,
				renderCell: (params) => {
					return (
						<Chip
							label="24"
							sx={{
								backgroundColor: 'rgba(255, 165, 0, 0.26)',
								border: '1px solid rgba(255, 165, 0, 0.28)',
								color: '#000000',
								fontSize: '14px',
								fontWeight: 400,
								padding: '2px 16px',
								borderRadius: '25px',
								marginRight: '40px'
							}}
						/>
					)
				}
			},
			{
				field: 'Emp_Emt',
				headerName: 'EMT',
				flex: 1,
				minWidth: 120,
				filterOperators: getGridStringOperators().filter(
					(operator) => operator.value === "contains"
				),
			},
		];
		if (checkbox == true) {
			columnsArr.splice(0,0,
			{
				field: " ",
				headerName: " ",
				flex: 1,
				maxWidth: 70,
				renderCell: (params) => (
					params?.row?.shift_assigned ==	false  &&
						(<Checkbox
							checked={params?.row?.id == assign?.id}
							onClick={() => {setAssign(e => e == null ? params?.row : null)}}
							disabled={assign != null && assign?.id != params?.row?.id}
						/>)
				)
			}
	)
}
return columnsArr
}

  let columns2 = [
		{
				field: " ",
				headerName: " ",
				flex: 1,
				maxWidth: 70,
				renderCell: (params) => (
					params?.row?.shift_assigned == false  &&
						(<Checkbox
							checked={params?.row?.id == assign?.id}
							onClick={() => {setAssign(e => e == null ? params?.row : null)}}
							disabled={assign != null && assign?.id != params?.row?.id}
						/>)
				)
		},
    {
      field: 'Name', headerName: 'Name', flex: 1,
      renderCell: (params) => {
        return ((params?.row?.EA_Rank ? params?.row?.EA_Rank : '') + ' ' + params?.row?.First_name + ' ' + params?.row?.Last_name)
      }
    },
    {
      field: 'hours', headerName: 'Duration', flex: 1,
      renderCell: (params) => {
        return (
          <Chip
            label={params?.row?.shift_type}
            sx={{
              backgroundColor: params?.row?.shift_type == 'Night' ? '#3498db29' : 'rgba(255, 165, 0, 0.26)',
              border: params?.row?.shift_type == 'Night' ? '1px solid #3498db33' : '1px solid rgba(255, 165, 0, 0.28)',
              color: '#000000',
              fontSize: '14px',
              fontWeight: 400,
              padding: '2px 16px',
              borderRadius: '25px',
              marginRight: '40px'
            }}
          />
        )
      }
    },
    {
      field: 'Emp_Emt',
      headerName: 'EMT',
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];

	const getData = () =>{
		 ApiService.get(`/scheduleAvailability?shift_date=${data?.date}`)
      .then(({ data: responseData }) => {
        const res = responseData?.data;

        if (displayFlag) {
          const allAvailableRows = [];
          const allUnavailableRows = [];

          Object.entries(res?.Available || {}).forEach(([outerKey, innerObj]) => {
            Object.entries(innerObj || {}).forEach(([innerKey, items]) => {
              if (Array.isArray(items) && items.length > 0) {
                const rowsWithId = items.map((item, index) => ({
                  id: item.Emp_Code || `${outerKey}-${innerKey}-${index}`,
                  ...item,
                }));
                allAvailableRows.push(...rowsWithId);
              }
            });
          });

          Object.entries(res?.Unavailable || {}).forEach(([outerKey, innerObj]) => {
            Object.entries(innerObj || {}).forEach(([innerKey, items]) => {
              if (Array.isArray(items) && items.length > 0) {
                const rowsWithId = items.map((item, index) => ({
                  id: item.Emp_Code || `${outerKey}-${innerKey}-${index}`,
                  ...item,
                }));
                allUnavailableRows.push(...rowsWithId);
              }
            });
          });

          if (allAvailableRows.length > 0) setAvailableData(allAvailableRows);
          if (allUnavailableRows.length > 0) setUnAvailableData(allUnavailableRows);
        }
        else {
          const allAvailabilityData = [];
          Object.entries(res?.Available || {}).forEach(([shiftType, innerData]) => {
            Object.entries(innerData || {}).forEach(([category, items]) => {
              if (Array.isArray(items) && items.length > 0) {
                const withMeta = items.map((item, index) => ({
                  ...item,
                  id: `${index}-${item.Emp_Code}-${shiftType}-${category}`,
                  shift_type: shiftType,
                }));
                allAvailabilityData.push(...withMeta);
              }
            });
          });

          setAvailabilityData(allAvailabilityData);
        }
      })
      .catch((err) => {
        console.error('error', err);
      });
	}

  useEffect(() => {
    if (!data?.date) return;
		getData()
  }, [data?.date, displayFlag, key, isReload]);
	
		const assignShift = () => {
		let body = {
			"Shift_Date": data?.date,
			"Shift_Code": assign?.Shift_Code,
			"Emp_Code": assign?.Emp_Code
		};
		ApiService.post("/assignShift", body)
			.then((data) => {
				toast.success(data?.message)
				setAssign(null)
				setIsReload(val=>!val)
				getData()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

  return (
    <>
      {availabilityData && availabilityData.length > 0 &&
			<>
        <CollapseComponent
          rows={availabilityData}
          columns={columns2}
          name={'Availability'}
          checkboxSelection={false}
          open={open}
          onExpandChange={onExpandChange}
        />		
				<div className='m-3 pb-2' style={{ display: 'flex', justifyContent: 'flex-start' }}>
					<ButtonTheme type='submit' variant="filled" color='primary'
						className='px-5'
						onClick={() => assignShift()}
						disabled={availabilityData.find(a => a?.shift_assigned ==	false) ? false : true}
					>
						Assign
					</ButtonTheme>
				</div>
			</>
      }

      {availableData && availableData.length > 0 &&
			<>
        <CollapseComponent
          rows={availableData}
          columns={columns(true)}
          name={'Available'}
          checkboxSelection={false}
          open={open}
          onExpandChange={onExpandChange}
        />
				<div className='m-3 pb-2' style={{ display: 'flex', justifyContent: 'flex-start' }}>
					<ButtonTheme type='submit' variant="filled" color='primary'
						className='px-5'
						onClick={() => assignShift()}
						disabled={availableData.find(a => a?.shift_assigned ==	false) ? false : true}
					>
						Assign
					</ButtonTheme>
				</div>
			</>
      }

      {unavailableData && unavailableData.length > 0 &&
        <CollapseComponent
          rows={unavailableData}
          columns={columns()}
          name={'Unavailable'}
          checkboxSelection={false}
          open={open}
          onExpandChange={onExpandChange}
        />
      }
    </>
  );
}
